import React, { useState, useEffect } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { DataTable } from "../../../components/tables";
import { PercentageDataGridCols } from "./data-grid-cols";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import moment from "moment";
import { toast } from "react-toastify";

const PercentageList = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [percentageData, setPercentageData] = useState([]);
  const [filteredPercentage, setFilteredPercentage] = useState([]);


  const handleCancel = () => {
    setName("");
    setFilteredPercentage(percentageData)
  };
  const handleSearch = () => {
    const filteredData = percentageData.filter((item: any) =>
      (item.userBatchName || "").toLowerCase().includes(name.toLowerCase())
    );
    setFilteredPercentage(filteredData);
  };
  
  const handleCreateUser = () => {
    navigate("/admin/createpercentage");
  };
  useEffect(() => {
    getRegisters();
  }, []);

  const getRegisters = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllPercentageList(data).then((res: any) => {
      if (res.status === "Success") {
        if (res.data) {
          const formattedData = res.data.map((item: any) => {
            return {
              ...item,
              createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
            };
          });
          setPercentageData(formattedData);
          setFilteredPercentage(formattedData)
        }
      } else {
        toast.error(res.message);
      }
    });
  };
  const handleEditUser = (data: any) => {
    navigate("/admin/editPercentage", { state: data });
  };
  const deleteMeetInfo = (meetId: string) => {
    const payload = {
      batchId: meetId,
    };
    AdminService.deletePercentage(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getRegisters();
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            <div className="row">
              <div className="col-md-6 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <b>Percentage List</b>
                </label>
                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e: any) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the BatchName"
                  />
                  <button
                    className="btn btn-primary rounded px-4 py-1"
                    onClick={() => handleSearch()}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="text-end">
                  <button
                    className="btn btn-success"
                    onClick={handleCreateUser}
                  >
                    Create Percentage
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <DataTable
                tableData={filteredPercentage}
                TableCols={PercentageDataGridCols}
                handleEditUser={handleEditUser}
                deleteMeetInfo={deleteMeetInfo}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PercentageList;
